import { CSSProperties, forwardRef } from "react";
import hoverStyles from "../../../styles/hover.module.css";

const StandardHoverBox = forwardRef<HTMLDivElement, { text: string; id?: string; style?: CSSProperties }>(
  ({ text, id, style }, ref) => {
    return (
      <div ref={ref} id={id} className={hoverStyles.smallHoverBox} style={style}>
        <p className="w-full">{text}</p>
      </div>
    );
  },
);

StandardHoverBox.displayName = "StandardHoverBox";

export default StandardHoverBox;
